<template>
  <component :is="layout">
    <RouterView v-slot="{ Component }">
      <Transition
        enterFromClass="opacity-0"
        enterActiveClass="transition duration-300"
      >
        <component :is="Component" />
      </Transition>
    </RouterView>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

defineOptions({
  name: 'TheAppLayout',
})

const route = useRoute()

const layout = computed(() => {
  const layout = route?.meta?.layout as AppLayouts

  if (layout) {
    return `The${layout}Layout`
  }
  return 'div'
})
</script>
